/*
Döljer alla outline på alla klickbara element men sätter en klass på body om besökaren börjar navigera sajten via TAB så att outline för alla klickbara element börjar synas igen. Om besökaren börjar använda musen igen så försvinner outlines igen.
*/

function handleFirstTab(e) {
	if (e.keyCode === 9) {
		document.body.classList.add("user-is-tabbing");
		window.removeEventListener("keydown", handleFirstTab);
		// eslint-disable-next-line no-use-before-define
		window.addEventListener("mousedown", handleMouseDownOnce);
	}
}

function handleMouseDownOnce() {
	document.body.classList.remove("user-is-tabbing");
	window.removeEventListener("mousedown", handleMouseDownOnce);
	window.addEventListener("keydown", handleFirstTab);
}
window.addEventListener("keydown", handleFirstTab);
